import React from 'react';
import { Dialog } from '../design-system/ui';
import { FeedbackForm } from './FeedbackForm';
import { Msg, useFormatMessage } from '../i18n-review/client/Msg';

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  source?: string;
  metadata?: Record<string, unknown>;
}

export function FeedbackModal({ isOpen, onClose, source = 'general', metadata }: FeedbackModalProps) {
  const formatMessage = useFormatMessage();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      closeLabel={formatMessage({
        id: 'feedback.modal.close',
        defaultMessage: 'Close',
        description: 'Button label to close feedback modal',
      })}
      title={<Msg id="feedback.modal.title" defaultMessage="Send Feedback" description="Title for feedback modal" />}
    >
      <p className="mb-6 leading-relaxed text-jc-ink-secondary">
        <Msg
          id="feedback.modal.description"
          defaultMessage="We'd love to hear your thoughts. Share your feedback to help us improve."
          description="Description text in feedback modal"
        />
      </p>
      <FeedbackForm
        source={source}
        metadata={metadata}
        onSuccess={(detail) => {
          const delayMs = detail?.authenticated ? 1500 : 5200;
          setTimeout(() => {
            onClose();
          }, delayMs);
        }}
        onCancel={onClose}
      />
    </Dialog>
  );
}
